export default __webpack_public_path__ + "static/media/portfolio-gif.e2921795.gif";